import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import store from './vuex/store'
import i18n from './i18n/i18n'

import {VueAxios} from "./http"

import Antd from 'ant-design-vue'
import {Icon, message, notification} from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.less'
// 改变主题
// import './theme/page.less'
import './theme/theme.less'
import 'animate.css'

import config from './config/default'
import VCharts from 'v-charts'
import VueSocketio from 'vue-socket.io'
import moment from 'moment'
import dataV from '@jiaminghi/data-view'

// 图片预览
// import Preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'

// lodsah
// import lodsah from 'lodash'

const lang = localStorage.getItem('lang') || 'zh-cn'

Vue.config.productionTip = false

// 设置moment国际化
moment.locale(lang)
// 挂载moment至Vue原型上
Vue.prototype.$moment = moment
const hostname = window.location.hostname
console.log(`hostname地址为： ${hostname}`)
console.log(`NODE_ENV环境为： ${process.env.NODE_ENV}`)
const socketUrl = process.env.NODE_ENV === 'production' ? `https://watch.zxsmart.cn:9098` : `http://${hostname}:9098`
// const socketUrl = process.env.NODE_ENV === 'development' ? `http://219.151.178.229:9096` : `http://${hostname}:9096`
// const socketUrl = `http://${hostname}:9098`
console.log(`socket的连接地址为： ${socketUrl}`)
//Vue.prototype.$lodash = lodsah
Vue.use(dataV)
Vue.use(VCharts)
Vue.use(Storage, config.storageOptions)
Vue.use(Antd)
Vue.use(VueAxios, router)
// Vue.use(VueSocketio, '192.168.1.202:3000')
Vue.use(new VueSocketio({
  debug: true,
  // connection: 'http://192.168.1.247:9098',target: 'http://watch.zxsmart.cn',
  connection: socketUrl,
//   connection: 'http://192.168.1.130:9098',
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
  // options: { path: "/my-app/" }
}))
// Vue.use(Preview)
//滚动条插件的包
// import PerfectScrollbar from 'perfect-scrollbar'
// //对应的css
// import "perfect-scrollbar/css/perfect-scrollbar.css"

// /**
//  * @description 自动判断该更新PerfectScrollbar还是创建它
//  * @param {HTMLElement} el - 必填。dom元素
//  */
// const el_scrollBar = (el) => {
//     //在元素上加点私货，名字随便取，确保不会和已有属性重复即可，我取名叫做_ps_
//     if (el.zx_ps instanceof PerfectScrollbar) {
//         el.zx_ps.update()
//     } else {
//         //el上挂一份属性
//         el.zx_ps = new PerfectScrollbar(el, { suppressScrollX: true })
//     }
// }

import {
    ACCESS_TOKEN,
    USER_NAME
} from '@/vuex/mutation-types'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

import {notificationConfig, messageConfig} from './config/globalConfig'

NProgress.configure({showSpinner: false})
//接着，自定义Vue指令,scrollBar
// Vue.directive("scrollBar", {
//     //使用inserted钩子函数（初次创建dom）获取使用自定义指令处的dom
//     inserted(el) {
//         //判断其样式是否存在position 并且position为"fixed", "absolute"或"relative"
//         //如果不符合条件，抛个错误。当然你也可以抛个警告然顺便给其position自动加上"relative"
//         //为什么要这么做呢，因为PerfectScrollbar实现原理就是对dom注入两个div，一个是x轴一个是y轴，他们两的position都是absolute。
//         //对css稍有常识的人都知道，absolute是相对于所有父节点里设置了position属性的最近的一个节点来定位的，为了能够正确定位，我们要给其设置position属性
//         const rules = ["fixed", "absolute", "relative"];
//         if (!rules.includes(window.getComputedStyle(el, null).position)) {
//             // console.log(`perfect-scrollbar所在的容器的position属性必须是以下之一：${rules.join("、")}`)
//         }
//         //el上挂一份属性
//         el_scrollBar(el);
//     },
//     //更新dom的时候
//     componentUpdated(el) {
//         try {
//             //vnode.context其实就是vue实例，这里其实无需实例也直接用Vue的静态方法
//             //故而也可以写成Vue.nextTick
//             Vue.nextTick(() => {
//                 el_scrollBar(el)
//             })

//         } catch (error) {
//             console.error(error)
//             el_scrollBar(el)
//         }
//     }
// })
router.beforeEach((to, from, next) => {
    NProgress.start()
    var username = Vue.ls.get(USER_NAME)
    // var token = Vue.ls.get(ACCESS_TOKEN)
    var token = localStorage.getItem(ACCESS_TOKEN)

    if (!to.matched.some(m => m.meta.skipAuth)) {
        // console.log(to)
        // 对路由进行验证
        if (username && token) { // 已经登陆
            next()
            NProgress.done()
        } else {
            // 未登录,跳转到登陆页面，并且带上 将要去的地址，方便登陆后跳转。
            next({path: '/login', query: {referrer: to.fullPath}})
            NProgress.done()
        }
    } else {
        next()
        NProgress.done()
    }
})
message.config(messageConfig)

notification.config(notificationConfig)

const ZxIcon = Icon.createFromIconfontCN({
    // 在 iconfont.cn 上生成 
     scriptUrl: 'https://at.alicdn.com/t/c/font_1125461_whp8ci644ue.js'
})
Vue.component('zx-icon', ZxIcon)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')